import React from 'react';

const Tabs = ({ obj, onClick, isActive }: TTabProps) => {

    const tabCSS = `tw-flex tw-justify-center tw-items-center tw-p-2 tw-cursor-pointer tw-border-b-2 tw-gap-2 tw-transition-all tw-duration-500 tw-ease-in-out ${isActive ? 'tw-border-[#0747A6]' : 'tw-border-transparent hover:tw-border-[#0747A6]'}`
    const disableTabCSS = `tw-flex tw-justify-center tw-items-center tw-p-2  tw-border-b-2 tw-gap-2 tw-transition-all tw-opacity-30
     tw-duration-500 tw-ease-in-out  tw-border-transparent hover:tw-border-[#0747A6]}`

    return (
        <div role="button" data-testid="components-arstabs-div-1" className={obj?.disable ? disableTabCSS : tabCSS} onClick={onClick} >
            {obj?.icon}
            < span className={`tw-font-medium tw-text-sm ${isActive ? 'tw-text-[#0747A6]' : ''}`}> {obj?.label}</span >
        </div >
    );
};

const ARSTabs = ({ tabLabels, activeTab, onTabClick }: TTabsProps) => {
    return (
        <div className="tw-flex tw-gap-10  ">
            {tabLabels.map((obj, index) => (
                <Tabs key={index} obj={obj} onClick={() => { if (!obj?.disable) onTabClick(index) }} isActive={index === activeTab} />
            ))}
        </div>
    );
};

export default ARSTabs;